<div class="sticky-buttons">
  <button
    *ngIf="canStoreFilter"
    [disabled]="!isFilterStoreDisabled"
    mat-stroked-button
    color="primary"
    class="sidenav-btn"
    (click)="openStoreFilterDialog()"
  >
    {{ "SEARCH.SEARCH_BAR.TITLE.STORE_FILTER" | translate }}
  </button>
  <button
    mat-stroked-button
    color="primary"
    (click)="search()"
    class="sidenav-btn"
  >
    {{ "SEARCH.SEARCH_BAR.TITLE.APPLY" | translate }}
  </button>
  <button
    mat-stroked-button
    color="primary"
    (click)="clear()"
    class="sidenav-btn"
  >
    {{ "SEARCH.SEARCH_BAR.TITLE.DELETE_FILTERS" | translate }}
  </button>
</div>

<ng-template searchFieldHost></ng-template>

<button
  mat-stroked-button
  color="primary"
  (click)="search()"
  class="sidenav-btn"
>
  {{ "SEARCH.SEARCH_BAR.TITLE.APPLY" | translate }}
</button>
